import { Observable } from 'rxjs';
import { Card, CardFooter, CardOptions } from './card';
import { Container } from 'src/app/shared/models/container.types';
import { getContainerRouteSegment } from 'src/app/shared/models/container-navigation';

export class ContainerCard extends Card {
    readonly navigationUrl: string;
    readonly cardTypeTranslationKey = 'card.type.project';
    readonly options;

    constructor(
        itemId: string,
        userId: string,
        userName: string,
        head: CardFooter,
        picture: string,
        container: Container,
        hideDeleteButton: boolean = false,
        disableDeleteButton: boolean = false
    ) {
        super(itemId, userId, userName, head, picture, container);
        this.options = new CardOptions(
            hideDeleteButton,
            disableDeleteButton,
            false,
            true
        );
        this.navigationUrl = getContainerRouteSegment(container.containerType);
    }

    public deleteCard(): Observable<unknown> {
        return this.deleteCardService.deleteProject(this.itemId);
    }

    public onCardPictureClick(): void {
        this.router.navigate([
            this.navigationUrl,
            this.rootObj.containerType,
            this.itemId,
        ]);
    }

    static convertToCard(
        container: Container,
        picture: string,
        hideDeleteButton: boolean
    ): ContainerCard {
        const pic = container.containerImage ?? null;

        return new ContainerCard(
            container.id,
            container.creator,
            container.creator,
            new CardFooter(container.name, picture),
            pic,
            container,
            hideDeleteButton,
            container.canNotBeDeleted
        );
    }
}
